export const collection = new Map()

export default function StaticRegister(namespace = 'default') {
  if (!collection.has(namespace)) {
    collection.set(namespace, new Map())
  }
  const subCollection = collection.get(namespace)

  function register(name, item) {
    subCollection.set(name, item)
  }

  function getItem(name) {
    return subCollection.get(name)
  }

  function hasItem(name) {
    return subCollection.has(name)
  }

  function getNames() {
    return [...subCollection.keys()]
  }

  function getValues() {
    return [...subCollection.values()]
  }

  return {
    register,
    getItem,
    hasItem,
    getNames,
    getValues,
  }
}
